<template>
    <div>
      <div class="modal hide fade" id="modalManufactureMaterial" tabindex="-1" role="dialog" aria-labelledby="modalManufactureMaterial" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title"><b>[{{ mproduct.product_no }}]</b> {{ getProductName }} ({{ mproductLength }})</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                      <table class="table table-item table-sm table-hover table-striped">
                        <thead>
                          <th>Material</th>
                          <th>Category</th>
                          <th>Qty</th>
                          <th>Uom</th>
                          <th class="text-right">cogs</th>
                          <th class="text-right">Total</th>
                        </thead>
                        <tbody>
                          <tr v-for="m in detailList" :key="m.id">
                            <td>[{{ m.product_no }}] {{ m.product }}</td>
                            <td>{{ m.category_id }}</td>
                            <td>{{ m.qty }}</td>
                            <td>{{ m.uom_id }}</td>
                            <td class="text-right">{{ m.price | currency }}</td>
                            <td class="text-right">{{ m.total_cogs | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><span class="font-13"><b>Total Material</b></span></td>
                            <td class="text-right"><span class="font-13">{{ totalCogs | currency}}</span></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><span class="font-13"><b>Total Product Qty</b></span></td>
                            <td class="text-right"><span class="font-13">{{ mproduct.qty_estimated }}</span></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><span class="font-13"><b>COGS per item</b></span></td>
                            <td class="text-right"><span class="font-13">{{ totalCostItem | currency }}</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-hard-primary" data-dismiss="modal" @click="process">Process</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ManufactureMaterialModal',
  props: ['material', 'mproduct', 'materialAdditional', 'mproductLength'],
  computed: {
    ...mapState({
      productListSelect: state => state.products.productListSelect
    }),
    getProductName () {
      var name = ''
      var pl = this.productListSelect.find(d => d.product_no === this.mproduct.product_no)
      if (pl) {
        name = pl.product_name
      }
      return name
    },
    totalCostItem () {
      var total = this.totalCogs / parseFloat(this.mproduct.qty_estimated)
      return total
    },

    totalCogs () {
      var sum = 0
      for (let i = 0; i < this.detailList.length; i++) {
        sum += parseFloat(this.detailList[i].total_cogs)
      }
      return sum
    },
    detailList () {
      var array = this.material.filter(d => d.category_id !== 'non-cost')
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var product = this.productListSelect.find(d => d.product_no === array[i].product_no)
        var mproduct = this.productListSelect.find(d => d.product_no === array[i].product_no)
        var obj = {
          id: array[i].id,
          manufacture_no: array[i].manufacture_no,
          product_no: array[i].product_no,
          product: product ? product.product_name : null,
          qty: array[i].qty,
          uom_id: array[i].uom_id,
          price: array[i].price,
          total_cogs: array[i].total_cogs,
          warehouse_no: array[i].warehouse_no,
          receive: array[i].receive,
          received_by: array[i].received_by,
          receive_date: array[i].receive_date,
          manufacture_date: array[i].manufacture_date,
          company_no: array[i].company_no,
          branch_no: array[i].branch_no,
          category_id: array[i].category_id,
          type_id: array[i].type_id,
          hand_id: array[i].hand_id,
          mproduct_no: array[i].mproduct_no,
          mproduct: mproduct ? mproduct.product_name : null
        }
        loop.push(obj)
      }
      var array2 = this.materialAdditional
      console.log('mprodudct2')
      console.log(array2)
      for (let i = 0; i < array2.length; i++) {
        var product2 = this.productListSelect.find(d => d.product_no === array2[i].product_no)
        var mproduct2 = this.productListSelect.find(d => d.product_no === array[i].product_no)
        if (array2.mproduct_no == null) {
          var cogs = parseFloat(array2[i].total_cogs) / this.mproductLength
          var totalCOGS = cogs * this.mproduct.qty_estimated
          var obj2 = {
            id: array2[i].id + 'additional',
            manufacture_no: array2[i].manufacture_no,
            product_no: array2[i].product_no,
            product: product2 ? product2.product_name : null,
            qty: null,
            uom_id: array2[i].uom_id,
            price: cogs,
            total_cogs: totalCOGS,
            warehouse_no: array2[i].warehouse_no,
            receive: array2[i].receive,
            received_by: array2[i].received_by,
            receive_date: array2[i].receive_date,
            manufacture_date: array2[i].manufacture_date,
            company_no: array2[i].company_no,
            branch_no: array2[i].branch_no,
            category_id: array2[i].category_id,
            type_id: array2[i].type_id,
            hand_id: array2[i].hand_id,
            mproduct_no: array2[i].mproduct_no,
            mproduct: mproduct2 ? mproduct2.product_name : null
          }
          loop.push(obj2)
        }
      }
      return loop
    }
  },
  methods: {
    process () {
      this.$emit('setPriceProduct', this.totalCostItem)
    }
  }
}
</script>
